import { render, staticRenderFns } from "./OtpCodeExpiry.vue?vue&type=template&id=43bbff3b&scoped=true"
import script from "./OtpCodeExpiry.vue?vue&type=script&lang=js"
export * from "./OtpCodeExpiry.vue?vue&type=script&lang=js"
import style0 from "./OtpCodeExpiry.vue?vue&type=style&index=0&id=43bbff3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bbff3b",
  null
  
)

export default component.exports